// import request from '@/axios'
import request from '@/axios/designManager'

// d-05-(rad2)空间需求评估列表
export function getSpaceEvaluatingList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getSpaceEvaluatingList',
    method: 'post',
    data
  })
}

// (rad2)-01-用户接受邀请
export function saveInviteStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/saveInviteStatus',
    method: 'post',
    data
  })
}

// (rad2)-02-空间列表
export function getSpaceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/getSpaceList',
    method: 'post',
    data
  })
}

// (rad2)-03-获取空间需求列表
export function getSpaceDemandDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/getSpaceDemandDetail',
    method: 'post',
    data
  })
}

// (rad2)-04-空间需求提交
export function saveDemand(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/saveDemand',
    method: 'post',
    data
  })
}

// (rad2)-05-预勘测信息发送设计师
export function sendDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/sendDesigner',
    method: 'post',
    data
  })
}

// (rad2)-06-用户基本信息
export function getCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/getCustomerInfo',
    method: 'post',
    data
  })
}

// designer-01-设计服务空间列表
export function getOtherSpaces(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_two/getOtherSpaces',
    method: 'post',
    data
  })
}
